import PropertyDetailOverview from './PropertyDetailOverview.vue';

export default PropertyDetailOverview;